import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
import { Badge, BadgedBox, Identicon, Tooltip, useSurfaceColorAtElevation } from '@talismn/ui';
import { Eye } from '@talismn/web-icons';
const AccountIcon = ({ address, readonly, ...props }) => {
    const theme = useTheme();
    const surfaceColor = useSurfaceColorAtElevation(x => x + 1);
    const size = typeof props.size === 'number' ? `${props.size}px` : props.size ?? '2.4rem';
    return (_jsx(BadgedBox, { overlap: "circular", badge: readonly && (_jsx(Tooltip, { content: "Watch only account", children: _jsx(Badge, { containerColor: surfaceColor, contentColor: theme.color.onSurface, css: { fontSize: `calc(${size} / 3.5)` }, children: _jsx(Eye, {}) }) })), children: _jsx(Identicon, { ...props, size: size, value: address }) }));
};
export default AccountIcon;
//# sourceMappingURL=AccountIcon.js.map